export class Sound {
  private context?: AudioContext;
  muted = true;
  toggle(): boolean { this.muted = !this.muted; if (!this.muted) this.chime('found'); return this.muted; }
  cat(kind: 'purr' | 'snore'): void {
    if (this.muted) return;
    try {
      this.context ??= new AudioContext(); void this.context.resume();
      const oscillator = this.context.createOscillator(); const volume = this.context.createGain();
      const tremolo = this.context.createOscillator(); const depth = this.context.createGain();
      const start = this.context.currentTime; const duration = kind === 'purr' ? 1.1 : .65;
      oscillator.type = 'triangle'; oscillator.frequency.setValueAtTime(kind === 'purr' ? 95 : 140, start);
      oscillator.frequency.exponentialRampToValueAtTime(kind === 'purr' ? 80 : 65, start + duration);
      volume.gain.setValueAtTime(0, start); volume.gain.linearRampToValueAtTime(.025, start + .1); volume.gain.linearRampToValueAtTime(0, start + duration);
      tremolo.frequency.value = kind === 'purr' ? 22 : 7; depth.gain.value = .007;
      tremolo.connect(depth); depth.connect(volume.gain); oscillator.connect(volume); volume.connect(this.context.destination);
      oscillator.start(start); tremolo.start(start); oscillator.stop(start + duration); tremolo.stop(start + duration);
    } catch { this.muted = true; }
  }
  chime(kind: 'found' | 'place' | 'win'): void {
    if (this.muted) return;
    try {
      this.context ??= new AudioContext(); void this.context.resume();
      const notes = kind === 'win' ? [523, 659, 784, 1046] : kind === 'place' ? [523, 784, 988] : [880, 1175];
      notes.forEach((frequency, i) => {
        const oscillator = this.context!.createOscillator(); const gain = this.context!.createGain();
        const start = this.context!.currentTime + i * .1; oscillator.type = 'sine'; oscillator.frequency.value = frequency;
        gain.gain.setValueAtTime(0, start); gain.gain.linearRampToValueAtTime(.06, start + .015); gain.gain.exponentialRampToValueAtTime(.001, start + .4);
        oscillator.connect(gain); gain.connect(this.context!.destination); oscillator.start(start); oscillator.stop(start + .45);
      });
    } catch { this.muted = true; }
  }
}
